<template>
  <v-card>
    <div class="pa-4">
      <h4>My Bio</h4>
    </div>
    <v-divider></v-divider>
    <div class="pa-4">
      <small>
      {{authUser.my_bio}}
      </small>
    </div>
  </v-card>
</template>

<script>
export default {
  name:"AboutYou"
};
</script>

<style scoped>
</style>